export function getNavItems(accountType) {
    const base = [
        { id: "dashboard", icon: "📊", label: "Dashboard" },
        { id: "products", icon: "🏷️", label: "商品資料" },
        { id: "promotions", icon: "🎯", label: "Promotion" },
    ];
    if (accountType === "admin") base.push({ id: "map", icon: "🗺️", label: "地圖系統" });
    if (accountType === "retail") base.push({ id: "payment", icon: "💰", label: "支付模組" });
    if (accountType === "developer") base.push({ id: "devtools", icon: "🛠️", label: "系統測試" });
    return base;
}